import React from "react";
import Axios from 'axios'
import API from '../Utils/api'
import {getUsuarioFromStorage} from "../Utils/usuarioHelper";
import DetalhamentoCaixa from "../_Components/DetalhamentoCaixa";
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';
import { Link } from 'react-router-dom';

export class MasterCaixasCambistas extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            feed: [],
            index: 0,
            cambistas: [],
            cambistaSelecionado: null,
            filteredList: []
        };
        this.listarCambistas()
        this.selecionarCambista = this.selecionarCambista.bind(this)
        this.deselecionarCambista = this.deselecionarCambista.bind(this)
        this.zerarCaixa = this.zerarCaixa.bind(this)
        this.zerarTodosCaixas = this.zerarTodosCaixas.bind(this)
        this.setIndex = this.setIndex.bind(this)
    }

    setIndex(event) {

        const {indexStart, indexEnd, countPages, lastIndex} = this.state;
        var index = parseInt(event.target.accessKey)
        this.setState({indexStart: (countPages * index), indexEnd: 2 + (countPages * index), lastIndex: index})
    }

    deselecionarCambista() {
        this.setState({cambistaSelecionado: null})
        this.forceUpdate()
    }

    selecionarCambista(event) {

        this.setState({cambistaSelecionado: event.target.accessKey})
        this.forceUpdate()
    }


    formatDate(data) {
    return moment(data).add(0,'days').format('DD-MM-YYYY')
    }

    getUser = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/user", {
                id: this.state.user._id
            });

            window.localStorage.setItem("user", JSON.stringify(response.data[0]));
            this.setState({user: response.data[0]});
        } catch (err) {
            console.log(err);
        }
    };

    gerarFeed() {
        this.state.cambistas.map(cambista => {
            this.getTransacoes(cambista)
        })
        this.setState({feed: this.state.feed})
        this.setState({filteredList : this.state.feed})
        this.forceUpdate()
    }

    async getTransacoes(cambista) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const {data} = await axiosInstance.post("transacoes/por-user", {
                userId: cambista._id
            });
            this.state.feed.push({cambista, transacaoes: data})
            this.setState({filteredList : this.state.feed})
            this.forceUpdate()
        } catch (err) {
            console.log(err);
        }
    };

    listarCambistas = async (e) => {
        try {
            const response = await API.post("/api/usuarios/listar-todos-cambistas", {});
            this.setState({cambistas: response.data});

            if (this.state.cambistas)
                this.gerarFeed()
        } catch (err) {
            console.log(err);
        }
    };

    gerarSaldos(user) {
        var entradas = 0;
        var saidas = 0;
        var comissao = 0;
        if (user.transacaoes)
            user.transacaoes.map(item => {
                if (item.emissorId._id != user._id) {
                    entradas += item.valor
                } else if (item.emissorId._id == user._id) {
                    saidas += item.valor
                }
            })
        var comissao = (entradas * user.cambista.comissao) / 100
        return {"entradas": entradas, "saidas": saidas, "pendencias": (entradas - comissao), "comissao": comissao}
    }

    async efetivarTransacao(transacao) {
        try {
            const response = await API.post("/api/transacoes/efetivar-transacao", {
                id: transacao._id
            });
            alert("Transação efetivada!")
        } catch (err) {
            console.log(err);
        }
    }

    async validarPedido(pedido) {
        try {
            const response = await API.post("/api/pedidos/validar-pedido", {
                id: pedido.transacaoId
            });
            alert("Pedido validado!")
        } catch (err) {
            console.log(err);
        }
    }

    async zerarCaixa(e) {
        const cambista = JSON.parse(e.target.accessKey);
        try {
            const response = await API.post("/api/transacoes/zerar-caixa", {
                id: cambista._id
            });
            alert("Cartelas validadas com sucesso!")
            window.location.reload()
        } catch (err) {
            console.log(err);
        }
    }

    async zerarTodosCaixas(e) {
        try {
            const response = await API.post("/api/transacoes/zerar-todos-caixas", {});
            alert("Cartelas validadas com sucesso!")
            window.location.reload()
        } catch (err) {
            console.log(err);
            alert("Caixas vazios!")
        }
    }

    nextIndex(){
        if(this.state.index < (this.state.feed.length)/10)
        this.setState({index: this.state.index+1})
    }
    prevIndex(){
        if(this.state.index > 0)
        this.setState({index: this.state.index-1})
    }

    paginador(){
        // return this.state.feed.sort(this.compararNome).slice(this.state.index * 10,(this.state.index*10)+10)
         return this.state.filteredList.sort(this.compararNome).slice(this.state.index * 10,(this.state.index*10)+10)
    }

    compararNome (a, b) {
        if (a.cambista.nome.toLowerCase() > b.cambista.nome.toLowerCase()) {
          return 1;
        }
        if (a.cambista.nome.toLowerCase() < b.cambista.nome.toLowerCase()) {
          return -1;
        }

        return 0
      }

      searchName(e){
        var filteredList  = this.state.feed.filter(usuario => 
          {
            if(usuario.cambista != undefined && usuario.cambista.nome.toLowerCase().includes(e.target.value.toLowerCase())){
            return usuario;
          }
        }
        )
        
        this.setState({filteredList : filteredList})
    }

    render() {
        return (
            <MasterTemplate label="Caixa Cambistas">
                <div  onClick={this.deselecionarCambista}  class="modal fade" id="exampleModalCenter" tabIndex="-1"
                     role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" style={{maxWidth: '95vw', marginTop: '-10em'}}
                         role="document">
                        <div className="modal-content ">
                            <div className="modal-header">
                                <h4 className="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento
                                    caixa</h4>
                                <button onClick={this.deselecionarCambista} type="button" className="close"
                                        data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {this.state.cambistaSelecionado ?
                                    <DetalhamentoCaixa user={this.state.cambistaSelecionado}/> : ""}
                            </div>
                            <div className="modal-footer" style={{justifyContent: 'flex-end'}}>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal w-50" id="exampleModal2" style={{marginLeft: '20em'}} tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Alerta</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Validar todos os pedidos!</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn-fill btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <button type="button"  data-dismiss="modal"  onClick={this.zerarTodosCaixas}  class="btn-fill btn btn-primary">Confirmar</button>
                        </div>
                        </div>
                    </div>
                </div>

              <div className="container-fluid">

                <div className="row">
                  <div className="col-md-12">
                    <div className="card strpied-tabled-with-hover">
                      <div className="card-header ">
                        <h4 className="card-title">Acompanhe caixa de seus cambistas</h4>
                        <p className="card-category">Informações de movimentações.</p>
                      </div>
                      <div className="card-body table-full-width table-responsive">
                      <div class="row">
                        <div class="col">
                        </div>

                            <div class="col">

                                        <input className="form-control w-100" placeholder="busca rapida..." onChange={this.searchName.bind(this)}></input>

                            </div>
                            <div class="col"></div>
                            <div class="col">
                            <button className="ml-2 btn-fill btn btn-danger"
                                     data-toggle="modal" data-dismiss="modal" data-target="#exampleModal2"  >Validar todos
                            </button>
                            </div>

                        </div>
                        <table className="table table-hover table-striped">
                          <thead>
                          <tr>
                              <th>no.</th>
                            <th>Nome</th>
                            <th>Entradas</th>
                            <th>Comissão</th>
                            <th>Saldo a receber</th>
                            <th>Validar pedidos</th>
                          </tr>
                          </thead>
                          <tbody>
                          {this.state.feed ? this.paginador().map((item, index) => {

                            const saldos = this.gerarSaldos(item)


                            return (
                                <tr
                                    className=
                                        "font-weight-bold "
                                >
                                    <td>{this.state.feed.indexOf(item) + 1}</td>
                                  <td style={{cursor: 'pointer'}}
                                      accessKey={JSON.stringify(item.cambista)}
                                      data-toggle="modal"
                                      data-target="#exampleModalCenter"
                                      onClick={this.selecionarCambista}>{item.cambista.nome}</td>

                                  <td style={{cursor: 'pointer'}}
                                      accessKey={JSON.stringify(item.cambista)}
                                      data-toggle="modal"
                                      data-target="#exampleModalCenter"
                                      onClick={this.selecionarCambista}>{saldos.entradas.toFixed(2)}</td>

                                  <td style={{cursor: 'pointer'}}
                                      accessKey={JSON.stringify(item.cambista)}
                                      data-toggle="modal"
                                      data-target="#exampleModalCenter"
                                      onClick={this.selecionarCambista}>{saldos.comissao.toFixed(2)}</td>

                                <td style={{cursor: 'pointer'}}
                                      accessKey={JSON.stringify(item.cambista)}
                                      data-toggle="modal"
                                      data-target="#exampleModalCenter"
                                      onClick={this.selecionarCambista}>{saldos.pendencias.toFixed(2)}</td>

                                  <td>
                                    <button className="btn-fill btn btn-primary"
                                            disabled={saldos.pendencias == 0 ? true : false}
                                            accessKey={JSON.stringify(item.cambista)}
                                            onClick={this.zerarCaixa}>Validar
                                    </button>
                                  </td>
                                </tr>
                            );
                          }) : ""}

                          </tbody>
                        </table>
                        <div className="row justify-content-center">
                        <button className="btn-fill btn btn-danger" onClick={this.prevIndex.bind(this)}>⮜</button>                 
                        <button className="btn-fill btn btn-danger ml-1" onClick={this.nextIndex.bind(this)}>⮞</button>
                        </div>
    
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </MasterTemplate>
        );
    }
}

export default MasterCaixasCambistas;
